import React from "react";
import { Feature } from "../../constants/interfaces";

interface JoinProps {
  data: Feature[]
}

export const Join = (props: JoinProps) => {
  return (
    <div id="features" className="text-center">
      <div className="container text-center">
        <div style={{ marginTop: '100px' }}>
          <h2>Get Involved</h2>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div style={{ marginBottom: '100px', justifyContent: 'center', textAlign: 'center' }}>
              <h3>Students</h3>
              <p>Gain experience while honing industry-relevant skills and contributing to impactful work. Apply today!</p>
              <a href="/apply" type="button" className="btn btn-primary"
                style={{ color: '#ffffff', backgroundColor: '#0573e8' }}>
                Apply
              </a>
            </div>
          </div>
          <div className="col-md-6">
            <div>
              <h3>NPOs</h3>
              <p>Are you a non-profit organization interested in partnering with us? Fill out this form and our team will be in touch!</p>
              <div></div> {/* Spacer div with margin */}
              <a href="https://forms.gle/wFvCAmppvucpb2Wp6" type="button" className="btn btn-primary"
                style={{ color: '#ffffff', backgroundColor: '#0573e8' }} target="_blank" rel="noreferrer">
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};